//takes number and rounds it up to the nearest hundredths decimal place, good for currency values
export const roundToHundredths = (number) => {
    return (Math.ceil(100 * number)/100).toFixed(2);
 };